import { post } from './agent';

export default {
  create: (body) => post('/career-interest', body),
};
